__turbopack_context__.v({
  "form": "profile-menu-module__Ib3eDG__form",
  "identity": "profile-menu-module__Ib3eDG__identity",
  "identityAvatar": "profile-menu-module__Ib3eDG__identityAvatar",
  "identityEmail": "profile-menu-module__Ib3eDG__identityEmail",
  "identityName": "profile-menu-module__Ib3eDG__identityName",
  "identityText": "profile-menu-module__Ib3eDG__identityText",
  "trigger": "profile-menu-module__Ib3eDG__trigger",
});
